import { Slide, useTheme } from "@mui/material";
import { Sparkles } from "lucide-react";
import React from "react";
import ReactMarkdown from "react-markdown";
import {
  AvatarContainer,
  Container,
  MessageBox,
  MessageContainer,
  SuggestedQuestionChip,
  SuggestedQuestionsRow } from "./AISupportChatMessageBox.styles";
import avatarIcon from "../../../../assets/avatar.svg";
import { Icon } from "../../../Icon";
import { ChatAgentMessage } from "../../AISupportChat.types";
import AISupportChatSpinner from "../AISupportChatSpinner/AISupportChatSpinner.component";

interface AISupportChatMessageBoxProps {
  index: number;
  message: ChatAgentMessage;
  onSuggestionClick?: (question: string) => void;
}

const AISupportChatMessageBox = ({
  index,
  message,
  onSuggestionClick
}: AISupportChatMessageBoxProps) => {
  const theme = useTheme();
  const isAI = message.sender === "assistant";
  const hasContent = message.response !== "";
  const suggestedQuestions = message.suggested_questions ?? [];


  const MessageAvatar = () => {
    return (
      <>
        { isAI ? (
          <img src={ avatarIcon } alt={ "Avatar" } style={ { width: "100%", height: "100%" } } loading="lazy"/>
        ) : (
          <Icon
            icon="Icons_Profilo"
            color={ theme.customColors.textWidget }
            size={ 37 }
          />
        ) }
      </>
    );
  };

  return (
    <Slide direction={ "up" } in mountOnEnter unmountOnExit>
      <div>
        <Container isAI={ isAI } messageIndex={ index } gap={ "10px" }>
          <AvatarContainer theme={ theme } isAI={ isAI }>
            <MessageAvatar />
          </AvatarContainer>
          <MessageContainer theme={ theme } isAI={ isAI }>
            { !hasContent ? (
              <AISupportChatSpinner />
            ) : (
              <MessageBox>
                <ReactMarkdown>{ message.response }</ReactMarkdown>
              </MessageBox>
            ) }
          </MessageContainer>
        </Container>

        { isAI && hasContent && suggestedQuestions.length > 0 && (
          <SuggestedQuestionsRow>
            { suggestedQuestions.map((question, questionIndex) => (
              <SuggestedQuestionChip
                key={ `sugg_${index}_${questionIndex}` }
                chipIndex={ questionIndex }
                onClick={ () => onSuggestionClick?.(question) }
                disabled={ !onSuggestionClick }
                startIcon={ <Sparkles size={ 14 } /> }
              >
                { question }
              </SuggestedQuestionChip>
            )) }
          </SuggestedQuestionsRow>
        ) }
      </div>
    </Slide>
  );
};

export default AISupportChatMessageBox;
